// extracted by mini-css-extract-plugin
export default {"sorting-select":"Sorting_sorting-select__Fc60G"};